import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import './App.scss';
import { AppContextProvider } from './context/app-data.context';
import { AuthorizeComponent } from './core/authorize.component';
import { AppRoutes } from './routes';
import { SnackbarProvider } from './context/snackbar-context';

const primaryFont = 'var(--primary-font)';
const radiusLarge = 'var(--border-radius-large)';
const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 0,
    },
  },
});

const theme = createTheme({
  typography: {
    fontFamily: [primaryFont, 'cursive'].join(','),
  },

  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: radiusLarge,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: radiusLarge,
        },
      },
    },
  },
  palette: {
    primary: {
      main: primaryColor,
    },
  },
});

const router = createBrowserRouter(AppRoutes);

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          <AppContextProvider>
            <AuthorizeComponent>
              <RouterProvider router={router} fallbackElement={<div>Loading...</div>} />
            </AuthorizeComponent>
          </AppContextProvider>
        </QueryClientProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
